if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector('button')
          .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.startGalleryAutoplay();
      }

      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    startGalleryAutoplay() {
      const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
      if (!thumbnails.length) return;

      let index = 0;

      setInterval(() => {
        index = (index + 1) % thumbnails.length;
        const mediaId = thumbnails[index].dataset.target;

        this.setActiveMedia(mediaId, false);
        this.setActiveThumbnail(thumbnails[index]);
      }, 5000);
    }

    startGalleryAutoplay() {
      const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
      if (!thumbnails.length) return;

      let index = 0;
      let timeout;

      const getActiveDelay = (mediaId) => {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const hasVideo = activeMedia && activeMedia.querySelector('video, iframe, deferred-media');

        return hasVideo ? 13000 : 4000;
      };

      const goToNext = () => {
        index = (index + 1) % thumbnails.length;
        const mediaId = thumbnails[index].dataset.target;

        this.setActiveMedia(mediaId, false);
        this.setActiveThumbnail(thumbnails[index]);

        clearTimeout(timeout);
        timeout = setTimeout(goToNext, getActiveDelay(mediaId));
      };

      timeout = setTimeout(goToNext, 6000);

      this.addEventListener('mouseenter', () => clearTimeout(timeout));

      this.addEventListener('mouseleave', () => {
        clearTimeout(timeout);
        const currentMedia = this.elements.viewer.querySelector('.is-active[data-media-id]');
        const currentMediaId = currentMedia?.dataset.mediaId;
        timeout = setTimeout(goToNext, getActiveDelay(currentMediaId));
      });

      thumbnails.forEach((thumbnail, i) => {
        thumbnail.addEventListener('click', () => {
          index = i;
          clearTimeout(timeout);
        });
      });
    }

    onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // Prevent autoplay from pulling the page back up to the media gallery
          const activeMediaRect = activeMedia.getBoundingClientRect();
          const mediaIsVisible =
            activeMediaRect.top >= 0 &&
            activeMediaRect.bottom <= window.innerHeight;

          if (!mediaIsVisible) return;
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
